import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PaymentButton from '../components/PaymentButton';
import { Check } from 'lucide-react';

const Checkout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [projectInfo, setProjectInfo] = useState({
    projectId: 'default',
    projectName: 'Default Project'
  });
  
  // Parse project info from location state if available
  useEffect(() => {
    if (location.state?.projectId) {
      setProjectInfo({
        projectId: location.state.projectId,
        projectName: location.state.projectName || 'My Project'
      });
    }
  }, [location.state]);
  
  const planFeatures = [
    '30 Articles a month generated and published on auto-pilot',
    'Keyword Research made for you on auto-pilot',
    'AI Images generated in different styles',
    'Relevant YouTube videos integrated into articles',
    'Unlimited AI Rewrites',
    'Priority Support',
    'Unlimited Users in your Organization',
    'Integrates with WordPress, Webflow, Shopify and many other platforms'
  ];
  
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-bold text-center text-gray-900 mb-4">Complete Your Purchase</h1>
      <p className="text-center text-gray-600 mb-10">Step 2 of 3: Payment</p>
      
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg overflow-hidden">
        <div className="p-8">
          <div className="flex flex-col md:flex-row justify-between items-start mb-8">
            <div>
              <h2 className="text-2xl font-bold text-gray-900">HyperRank All-In-One</h2>
              <p className="text-lg text-primary-600 font-medium">$99/month</p>
            </div>
            
            {projectInfo.projectId !== 'default' && (
              <div className="bg-gray-50 rounded-lg p-4 mt-4 md:mt-0">
                <h3 className="font-medium text-gray-700">Project</h3>
                <p className="text-gray-900">{projectInfo.projectName}</p>
            </div>
            )}
          </div>
          
          <div className="mb-8">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Plan Features</h3>
            <ul className="space-y-3">
              {planFeatures.map((feature, index) => (
                <li key={index} className="flex items-start">
                  <div className="h-6 w-6 rounded-full bg-green-100 flex items-center justify-center mr-3 flex-shrink-0 mt-0.5">
                    <Check className="h-4 w-4 text-green-600" />
                  </div>
                  <span className="text-gray-700">{feature}</span>
                </li>
              ))}
            </ul>
          </div>
          
          <div className="border-t border-gray-200 pt-8">
            <div className="mb-6">
              <div className="flex justify-between text-base mb-1">
                <span className="font-medium text-gray-700">Subscription</span>
                <span className="text-gray-900">$99.00</span>
          </div>
              <div className="flex justify-between text-sm text-gray-500 mb-1">
                <span>Billed monthly</span>
                <span>Cancel anytime</span>
          </div>
          </div>
          
          <PaymentButton 
              planId="all-in-one"
              projectId={projectInfo.projectId}
              projectName={projectInfo.projectName}
              buttonText="Complete Purchase"
          />
          
            <p className="text-center text-sm text-gray-500 mt-4">
              By completing your purchase, you agree to our Terms of Service and Privacy Policy.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout; 